import * as React from 'react'
import { SVGProps } from 'react'
export const FoodIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    {...props}
  >
    <path
      fill="#858585"
      d="M1.75 38.5c0 .945.788 1.75 1.75 1.75h22.75c.98 0 1.75-.805 1.75-1.75v-1.75H1.75v1.75Zm13.125-22.75c-6.563 0-13.125 3.5-13.125 10.5H28c0-7-6.563-10.5-13.125-10.5Zm-8.54 7c1.942-2.712 6.073-3.5 8.54-3.5 2.468 0 6.598.788 8.54 3.5H6.335Zm-4.585 7H28v3.5H1.75v-3.5Zm29.75-21v-7H28v7h-8.75l.402 3.5h16.73l-2.45 24.5H31.5v3.5h3.01c1.47 0 2.678-1.138 2.852-2.572L40.25 8.75H31.5Z"
    />
  </svg>
)
